<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-4">
          <template slot="actions">
            <vs-button @click="onClickCreate()" class="mr-4 mb-4" color="primary" type="filled">Add Raw Material Stock Inventory</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-if="!its_product_code" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="sundry-item-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%"  class="text-sm">BATCH NO</vs-th>
                <vs-th width="10%"  class="text-sm" sort-key="sundry_item_code">ITS PRODUCT CODE</vs-th>
                <vs-th width="10%"  class="text-sm" sort-key="sundry_product_code">ITS PRODUCT NAME</vs-th>
                <vs-th width="5%"  class="text-sm" >SUPPLIER BATCH NUMBER</vs-th>
                <vs-th width="10%" class="text-sm">SHELF LOCATION</vs-th>
                <vs-th width="10%" class="text-sm">MANUFACTURE DATE</vs-th>
                <vs-th width="10%" class="text-sm">EXPIRATION DATE</vs-th>
                <vs-th width="10%" class="text-sm">QUANTITY (KG)</vs-th>
                <vs-th width="10%" class="text-sm">STATUS</vs-th>
                <vs-th width="10%" class="text-sm">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdateRmStock(data[indextr])" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].batch_no">
                    {{ data[indextr].batch_no}}
                  </vs-td>

                  <vs-td class="text-primary font-semibold" :data="data[indextr].company_product_code">
                    {{ data[indextr].category }}-{{ data[indextr].company_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].company_product_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_batch_no">
                    {{ data[indextr].supplier_batch_no}}
                  </vs-td>

                  <vs-td>
                    R {{ data[indextr].shelf_location_r || '-'}} | S {{ data[indextr].shelf_location_s || '-'}} | L {{ data[indextr].shelf_location_l || '-'}}
                  </vs-td>


                  <vs-td :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date}}
                  </vs-td>

                  <vs-td :data="data[indextr].expiration_date">
                    {{ data[indextr].expiration_date}}
                  </vs-td>

                  <vs-td :data="data[indextr].available_quantity">
                    {{ Number(data[indextr].available_quantity).toFixed(4)}}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                      {{ data[indextr].status}}
                    </vs-chip>
                  </vs-td>


                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="Update rm stock" position="bottom">
                        <vs-button class="ml-3"
                                   @click.stop="onClickUpdateRmStock(data[indextr])"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'" class="flex justify-start mr-2" text="Update/View QC Test" position="bottom">
                        <vs-button class="flex justify-end" @click.stop="onClickUpdateQcTest(data[indextr].q_c_test.id, data[indextr].rm_id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <update-rm-stock-pop-up v-on:refreshData="refreshData" ref="UpdateRmStockPopUp"/>
    <update-qc-test-rm-order-item-pop-up ref="updateQcTestRmOrderItemPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import UpdateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/UpdateRmStockPopUp";

  const InventoryRepository = RepositoryFactory.get('inventory')
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import UpdateQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/UpdateQcTestRmOrderItemPopUp";
  export default {
    name: 'RawMaterialStockInventory',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    props: {
      its_product_code: {
        type: String,
        default: ''
      }
    },
    components: {
      'v-select': vSelect,
      UpdateRmStockPopUp,
      UpdateQcTestRmOrderItemPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        this.fetchRmStockInventory()
        this.$emit('refreshData', '')
      },
      async fetchRmStockInventory() {
        await this.$vs.loading({
          container: '#sundry-item-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getRawMaterialStock(this.page, `filter[search]=${this.its_product_code}`, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
      },
      onClickCreate() {
        if(this.its_product_code) {
          // this.$parent.closePopup()
          this.$emit('closePopup', '')
        }
        this.$router.push({path: `/pages/manufacturing/raw-material-stock/create`})
      },
      filterQueryUpdate (){
        this.fetchRmStockInventory()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchRmStockInventory()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRmStockInventory()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      onClickUpdateRmStock(data) {
        this.$refs.UpdateRmStockPopUp.openPopup(data.id)
      },
      async onClickUpdateQcTest(test_id, rm_id) {
        await this.$refs.updateQcTestRmOrderItemPopUp.openPopup(test_id, rm_id)
      },
    },
    watch : {
      page(){
        this.fetchRmStockInventory()
      },
      perPage() {
        this.fetchRmStockInventory()
      },
      its_product_code() {
        this.fetchRmStockInventory()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
